/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".survey[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:end;align-items:flex-end}.survey__close[_ngcontent-%COMP%]{cursor:pointer}.survey__frame[_ngcontent-%COMP%]{display:block;width:600px;height:520px}@media (max-width:760px){.survey__frame[_ngcontent-%COMP%]{display:block;width:100%}}"];
export { styles as styles };
